import AwesomeNotifications from 'awesome-notifications'

export default class Register
{
	static explanation(template)
	{
		const notification = new AwesomeNotifications()

		// noinspection JSUnresolvedFunction
		const modal = notification.modal($(template).html())
		$(modal.el).find('video')[0].play()
	}

	static movie(player)
	{
		player.paused ? player.play() : player.pause()
	}
}
